( function () {
	'use strict';

	document.addEventListener( 'DOMContentLoaded', function () {
		document.querySelectorAll( '.aivb-chat-widget' ).forEach( initChat );
	} );

	function initChat( widget ) {
		const restBase   = widget.dataset.rest.replace( /chat$/, '' );
		const nonce      = widget.dataset.nonce;
		const openOnLoad = widget.dataset.open === 'true';
		const avatar     = widget.dataset.avatar || '🤖';

		const toggleBtn  = widget.querySelector( '.aivb-chat-toggle' );
		const closeBtn   = widget.querySelector( '.aivb-chat-close' );
		const chatWindow = widget.querySelector( '.aivb-chat-window' );
		const messagesEl = widget.querySelector( '.aivb-chat-messages' );
		const typingEl   = widget.querySelector( '.aivb-chat-typing' );
		const inputArea  = widget.querySelector( '.aivb-chat-input-area' );
		const input      = widget.querySelector( '.aivb-chat-input' );
		const sendBtn    = widget.querySelector( '.aivb-chat-send' );
		const loginGate  = widget.querySelector( '.aivb-chat-login' );
		const nameInput  = widget.querySelector( '.aivb-chat-name' );
		const emailInput = widget.querySelector( '.aivb-chat-email' );
		const loginBtn   = widget.querySelector( '.aivb-chat-login-btn' );
		const loginErr   = widget.querySelector( '.aivb-chat-login-error' );

		let sessionId   = localStorage.getItem( 'aivb_session_' + widget.id ) || '';
		let convId      = 0;
		let mode        = 'human';
		let busy        = false;
		let isOpen      = false;
		let pollTimer   = null;
		let lastMsgId   = 0;
		let loggedIn    = !! sessionId;
		let isFirstLoad = true;
		let pendingMsg  = '';

		// Open/close
		function openChat() {
			isOpen = true;
			chatWindow.classList.add( 'aivb-chat-window--open' );
			toggleBtn.setAttribute( 'aria-expanded', 'true' );
			toggleBtn.classList.add( 'aivb-chat-toggle--open' );
			if ( loggedIn ) {
				input && input.focus();
			} else {
				if ( loginGate && loginGate.style.display === 'flex' ) {
					nameInput && nameInput.focus();
				} else {
					input && input.focus();
				}
			}
		}

		function closeChat() {
			isOpen = false;
			chatWindow.classList.remove( 'aivb-chat-window--open' );
			toggleBtn.setAttribute( 'aria-expanded', 'false' );
			toggleBtn.classList.remove( 'aivb-chat-toggle--open' );
		}

		toggleBtn.addEventListener( 'click', () => isOpen ? closeChat() : openChat() );
		closeBtn  && closeBtn.addEventListener( 'click', closeChat );
		if ( openOnLoad ) setTimeout( openChat, 600 );

		// Show correct pane
		function showLoginGate() {
			loginGate && ( loginGate.style.display = 'flex' );
			inputArea && ( inputArea.style.display = 'none' );
		}

		function showChatPane() {
			loginGate && ( loginGate.style.display = 'none' );
			inputArea && ( inputArea.style.display = 'flex' );
		}

		// Always show chat pane first
		showChatPane();

		if ( loggedIn ) {
			startPoll();
		} else {
			appendMsg( 'bot', widget.dataset.welcome || 'Hi! How can I help you today?' );
			renderQuickQuestions();
		}

		// ── Render Quick Questions ─────────────────────────────────────────
		function renderQuickQuestions() {
			const questions = ( typeof aivbData !== 'undefined' && aivbData.commonQuestions ) ? aivbData.commonQuestions : [];
			if ( questions.length === 0 ) return;

			const wrap = document.createElement( 'div' );
			wrap.className = 'aivb-chat-quick-questions';

			const title = document.createElement( 'p' );
			title.className = 'aivb-chat-quick-questions-title';
			title.textContent = 'Common Questions:';
			wrap.appendChild( title );

			questions.forEach( q => {
				const btn = document.createElement( 'button' );
				btn.className = 'aivb-chat-qq-btn';
				btn.textContent = q.q;
				btn.addEventListener( 'click', () => {
					appendMsg( 'user', q.q );
					wrap.remove();
					setTimeout( () => {
						appendMsg( 'bot', q.a );
					}, 400 );
				} );
				wrap.appendChild( btn );
			} );

			messagesEl.appendChild( wrap );
			messagesEl.scrollTop = messagesEl.scrollHeight;
		}

		// ── Login ──────────────────────────────────────────────────────────
		loginBtn && loginBtn.addEventListener( 'click', startSession );
		emailInput && emailInput.addEventListener( 'keydown', e => { if(e.key==='Enter') startSession(); } );

		async function startSession() {
			const name  = nameInput  ? nameInput.value.trim()  : '';
			const email = emailInput ? emailInput.value.trim() : '';
			if ( !name || !email )                             { showErr( 'Please enter your name and email.' ); return; }
			if ( !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ) { showErr( 'Please enter a valid email.' ); return; }

			loginBtn.disabled = true;
			loginBtn.textContent = 'Starting…';
			try {
				const res  = await apiPost( restBase + 'chat/start', { name, email, session_id: sessionId || undefined } );
				const data = await res.json();
				if ( data.code ) { showErr( data.message || 'Error.' ); return; }

				sessionId = data.session_id;
				convId    = data.conversation_id;
				mode      = data.mode;
				loggedIn  = true;
				localStorage.setItem( 'aivb_session_' + widget.id, sessionId );

				showChatPane();
				startPoll();

				if ( pendingMsg ) {
					sendMsg();
				}
			} catch(e) {
				showErr( 'Could not connect. Please try again.' );
			} finally {
				loginBtn.disabled    = false;
				loginBtn.textContent = 'Start Chat';
			}
		}

		function showErr(msg) { if(loginErr){ loginErr.textContent=msg; loginErr.style.display='block'; } }

		// ── Send ───────────────────────────────────────────────────────────
		sendBtn && sendBtn.addEventListener( 'click', sendMsg );
		input   && input.addEventListener( 'keydown', e => { if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();sendMsg();} } );

		async function sendMsg() {
			const text = pendingMsg || ( input ? input.value.trim() : '' );
			if ( !text || busy ) return;

			if ( ! loggedIn ) {
				pendingMsg = text;
				if ( input ) input.value = '';
				showLoginGate();
				nameInput && nameInput.focus();
				return;
			}

			busy = true;
			if ( ! pendingMsg && input ) input.value = '';
			pendingMsg = '';
			sendBtn.disabled = true;
			appendMsg( 'user', text );

			try {
				await apiPost( restBase + 'chat/message', { session_id: sessionId, message: text } );
				appendSys( '✓ Sent — waiting for a reply from our team.' );
			} catch(e) {
				appendMsg( 'bot', 'Sorry, something went wrong. Please try again.' );
			} finally {
				busy = false; sendBtn.disabled = false;
				input && input.focus();
			}
		}

		// ── Poll ───────────────────────────────────────────────────────────
		function startPoll() {
			clearInterval( pollTimer );
			pollTimer = setInterval( poll, 5000 );
		}

		async function poll() {
			if ( !sessionId ) return;
			try {
				const url  = restBase + 'chat/poll?session_id=' + encodeURIComponent(sessionId) + '&after_id=' + lastMsgId;
				const res  = await fetch( url, { headers: { 'X-WP-Nonce': nonce } } );
				const data = await res.json();
				if ( data.mode ) mode = data.mode;

				const messages = data.messages || [];
				if ( isFirstLoad ) {
					messages.forEach( m => {
						if ( m.id > lastMsgId ) lastMsgId = m.id;
						if ( m.sender === 'user' ) {
							appendMsg( 'user', m.message );
						} else {
							appendMsg( 'bot', m.message );
						}
					} );
					isFirstLoad = false;
				} else {
					messages.forEach( m => {
						if ( m.id > lastMsgId ) lastMsgId = m.id;
						if ( m.sender === 'admin' || m.sender === 'ai' ) {
							appendMsg( 'bot', m.message );
						}
					} );
				}
			} catch(e) {}
		}

		// ── Helpers ────────────────────────────────────────────────────────
		function appendMsg( role, text ) {
			const d = document.createElement('div');
			d.className = 'aivb-chat-message aivb-chat-message--' + role;
			if ( role === 'bot' ) {
				d.innerHTML = `<span class="aivb-chat-message__avatar">${avatar}</span><div class="aivb-chat-message__bubble">${esc(text)}</div>`;
			} else {
				d.innerHTML = `<div class="aivb-chat-message__bubble">${esc(text)}</div>`;
			}
			messagesEl.appendChild(d);
			messagesEl.scrollTop = messagesEl.scrollHeight;
		}

		function appendSys( text ) {
			const d = document.createElement('div');
			d.className = 'aivb-chat-system-msg';
			d.textContent = text;
			messagesEl.appendChild(d);
			messagesEl.scrollTop = messagesEl.scrollHeight;
		}

		function apiPost( url, body ) {
			return fetch( url, { method:'POST', headers:{'Content-Type':'application/json','X-WP-Nonce':nonce}, body: JSON.stringify(body) } );
		}
	}

	function esc(s) {
		const m = {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'};
		return String(s).replace(/[&<>"']/g, c => m[c]);
	}
})();
